import styled from 'styled-components';
import { Button } from './button-base';
import { buttonStyleGenerator } from './button-style-generator';

export const NegativeButton = styled(Button)`
    ${({ outline }) => buttonStyleGenerator(outline ? 'negativeOutline' : 'negative')};
`;
